import React from 'react'

import { bemJoin } from 'bem-join'

import { ChatChronicItemType } from '@app/graphql/types'
import { useIntl } from '@app/intl/Intl'
import { PortalContentLayout } from '@app/lib/layout/PortalContentLayout/PortalContentLayout'
import { CourtCaseTabNames } from '@app/modules/CourtCases'
import { ChatChronic } from '@app/modules/CourtCases/Components/ChatChronic'
import { useCourtCaseContext } from '@app/modules/CourtCases/Components/CourtCaseContext/CourtCaseContext'
import { CourtCaseHeader } from '@app/modules/CourtCases/Components/CourtCaseHeader/CourtCaseHeader'
import ProfileBox from '@app/modules/Messages/Components/ProfileBox/ProfileBox'
import { NavBar } from '@app/NavBar'
import { CourtCaseEventFragment } from '@app/queries/CourtCases/CourtCase.queries'

import { CourtCaseTimeline } from '../Components/CourtCaseTimeline/CourtCaseTimeline'

import './styles.scss'

export const CourtCaseChatPage = () => {
  const b = bemJoin('court-case')

  const { formatMessage } = useIntl()
  const { data, loading } = useCourtCaseContext()

  const customer = data?.customer
  const product = data?.customer.membership?.product
  const events = (data?.chatChronic || [])
    .filter((item) => item.type === ChatChronicItemType.Event)
    .map((chronicItem) => chronicItem.item as CourtCaseEventFragment)
    .filter(Boolean)

  return (
    <NavBar title={formatMessage({ id: 'CourtCases.Title' })}>
      <PortalContentLayout className={b()}>
        <CourtCaseHeader activeTab={CourtCaseTabNames.ChatChronic} />
        <PortalContentLayout.MainPane>
          <PortalContentLayout.MainPane.Sidebar className={b('timeline')}>
            <CourtCaseTimeline timelineItems={events} />
          </PortalContentLayout.MainPane.Sidebar>
          <PortalContentLayout.MainPane.Content>
            <PortalContentLayout.Container>
              <ChatChronic />
            </PortalContentLayout.Container>
          </PortalContentLayout.MainPane.Content>
          <PortalContentLayout.MainPane.Sidebar>
            {!loading && customer && product && (
              <ProfileBox
                customer={customer}
                latestPurchase={product.name}
                upgradesTo={product.upgradesTo}
              />
            )}
          </PortalContentLayout.MainPane.Sidebar>
        </PortalContentLayout.MainPane>
      </PortalContentLayout>
    </NavBar>
  )
}
